module.exports = __webpack_public_path__ + "static/media/android-icon.3a7a4f41.svg";